// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productGridCardStyles } from "@west/Overrides/Widgets/ProductList/ProductListProductGridCard";
import { css } from "styled-components";

productGridCardStyles.productPriceAndActionsStyles = {
    productListGridContainer: {
        addToCartActions: {
            css: css`
                display: flex;
                flex-direction: column;
                gap: 12px;
            `,
        },
    },
    variantOptionsStyles: {
        wrapper: {
            css: css`
                margin-top: 8px;
            `,
        },
    },
    messagesContainer: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;
            min-height: 16px;
        `,
    },
};

productGridCardStyles.productListImageStyles = {
    wrapper: {
        css: css`
            position: relative;
        `,
    },

    productImage: {
        linkWrappingImage: {
            css: css`
                position: relative;
                height: 317px;
                width: 100%;
            `,
        },
        img: {
            width: 317,
            height: 317,
            css: css`
                max-width: 100%;
                max-height: 100%;
                height: auto;
            `,
        },
    },
};

productGridCardStyles.productInformationStyles = {
    container: {
        gap: 0,
    },
    descriptionGridItem: {
        css: css`
            display: flex;
            align-items: flex-start;
            padding-bottom: 8px;
            min-height: 40px;
        `,
    },
};

productGridCardStyles.productListGridContainerStyles = {
    container: {
        css: css`
            & > .middle-section {
                margin-top: auto;
            }

            & > .bottom-section {
                margin-top: unset;
            }
        `,
    },
    info: {
        css: css`
            height: auto;
        `,
    },
};
